import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import CloudWorldwarden from "./CloudWorldwarden";
import { cloudPersistenceEnabled } from "./lib/config";
import { supabaseConfigured } from "./lib/supabase";
import "./styles.css";

function ConfigurationError() {
  return (
    <main className="cloud-gate">
      <section className="cloud-card">
        <div className="brand-mark cloud-mark">✦</div>
        <div className="eyebrow">STARFALL WORKS / WORLDWARDEN</div>
        <h1>Development persistence is not configured</h1>
        <p>
          This deployment expects Supabase persistence, but the Supabase URL or
          publishable key is missing from the build environment.
        </p>
      </section>
    </main>
  );
}

function RootApp() {
  if (!cloudPersistenceEnabled) {
    return <App />;
  }

  if (!supabaseConfigured) {
    return <ConfigurationError />;
  }

  return <CloudWorldwarden />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RootApp />
  </StrictMode>,
);
